// extracted by mini-css-extract-plugin
module.exports = {"content":"InstallMiniVariantInterstitial_content__rKRLY","actions":"InstallMiniVariantInterstitial_actions__DzjBF"};